module.exports = __webpack_public_path__ + "img/s00132.4628e824.jpg";